var types = {
	ProgramId: "[u8;32]",
	Program: {
		_enum: {
			Active: "ActiveProgram",
			Exited: "ProgramId",
			Terminated: "ProgramId"
		}
	},
	WasmPageNumber: "u32",
	PageNumber: "u32",
	ReservationId: "[u8;32]",
	GasReservationSlot: {
		amount: "u64",
		start: "u32",
		finish: "u32"
	},
	ActiveProgram: {
		allocations: "BTreeSet<WasmPageNumber>",
		pages_with_data: "BTreeSet<PageNumber>",
		gas_reservation_map: "BTreeMap<ReservationId, GasReservationSlot>",
		code_hash: "H256",
		code_length_bytes: "u32",
		code_exports: "BTreeSet<DispatchKind>",
		static_pages: "WasmPageNumber",
		state: "ProgramState",
		expiration_block: "BlockNumber"
	},
	ProgramState: {
		_enum: {
			Uninitialized: {
				message_id: "MessageId"
			},
			Initialized: "Null"
		}
	},
	ExecutionResult: {
		_enum: {
			Success: "Null",
			Failure: "Vec<u8>"
		}
	},
	GasInfo: {
		min_limit: "u64",
		reserved: "u64",
		burned: "u64",
		may_be_returned: "u64",
		waited: "bool"
	}
};
var typesProgram = {
	types: types
};

export { typesProgram as default, types };
